import { render, staticRenderFns } from "./MonthlyEISAmbank.vue?vue&type=template&id=637f2dd2&scoped=true"
import script from "./MonthlyEISAmbank.vue?vue&type=script&lang=js"
export * from "./MonthlyEISAmbank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637f2dd2",
  null
  
)

export default component.exports